var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthGradientBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 79,
    viewBox: "0 0 1440 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_525_1851)",
    filter: "url(#filter0_b_525_1851)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_525_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.304 29.3088C371.002 -26.8304 92.7254 52.7001 0 99.4828V205H1440V46.7242C1362.14 64.3104 1113.61 85.448 742.304 29.3088Z",
    fill: "#0071BC",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.242 20.6386C1067.77 -35.5007 992.5 82.3297 1438 20.6385V196.33H1V38.054C78.6937 55.6402 209 94.6127 697.242 20.6386Z",
    fill: "#007ED1",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_525_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.304 56.3455C294.614 126.505 92.7254 79.732 0 126.505V232H1440V73.7573C1362.14 91.3398 1113.3 -1.79422 742.304 56.3455Z",
    fill: "#68C1FC",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.696 52.3455C1145.39 122.505 1347.27 75.732 1440 122.505V228H0V69.7573C77.8558 87.3398 326.704 -5.7942 697.696 52.3455Z",
    fill: "#F5F5F5",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_525_1851",
    x: -16,
    y: -16,
    width: 1472,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_525_1851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_525_1851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_525_1851",
    x: -40,
    y: -35,
    width: 1520,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_525_1851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_525_1851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_1851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 79,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_525_1851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 159,
    fill: "white",
    transform: "translate(0 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthGradientBg);
export default __webpack_public_path__ + "static/media/auth-gradient-bg.94d800a6c249cea8061453a70fb1e99c.svg";
export { ForwardRef as ReactComponent };